import { ThemeProvider } from "@mui/material/styles";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { store } from "./app/store";
import reportWebVitals from "./reportWebVitals";
import theme from "./theme";
import { initGoogleAnalytics } from "./utils/analytics";
import { WalletProvider } from "./wallet/WalletProvider";
import { ConfirmPopupProvider } from "@/shared/ui/ConfirmPopup";

import "./index.css";

TimeAgo.addDefaultLocale(en);

initGoogleAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <BrowserRouter
    future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
  >
    <Provider store={store}>
      <WalletProvider>
        <ThemeProvider theme={theme}>
          <ConfirmPopupProvider>
            <App />
          </ConfirmPopupProvider>
        </ThemeProvider>
      </WalletProvider>
    </Provider>
  </BrowserRouter>
);

reportWebVitals();
